/**
 * Utility functions for admin access control
 */

import { useTransactionCertificateStore } from '../../store/transaction-certificates.store';

/**
 * Check if user is an admin by checking originalAdminCBID
 * This ensures admin status persists even when viewing other CB-IDs
 * @returns boolean - true if user is admin
 */
export const isAdmin = (): boolean => {
  const { originalAdminCBID } = useTransactionCertificateStore.getState();
  
  if (!originalAdminCBID) {
    return false;
  }
  
  const adminCBIds = process.env.REACT_APP_ADMIN_CB_IDS || '';
  const adminList = adminCBIds.split(',').map(id => id.trim());
  
  return adminList.includes(originalAdminCBID);
};

/**
 * Check if a CB-ID is in the admin list from environment variables
 * @param cbId - The CB-ID to check
 * @returns boolean - true if CB-ID is in admin list
 */
export const isAdminCBID = (cbId: string): boolean => {
  if (!cbId) return false;
  
  const adminCBIds = process.env.REACT_APP_ADMIN_CB_IDS || '';
  const adminList = adminCBIds.split(',').map(id => id.trim());
  
  return adminList.includes(cbId);
};

/**
 * Get the list of admin CB-IDs from environment variables
 * @returns string[] - Array of admin CB-IDs
 */
export const getAdminCBIDList = (): string[] => {
  const adminCBIds = process.env.REACT_APP_ADMIN_CB_IDS || '';
  return adminCBIds.split(',').map(id => id.trim()).filter(id => id !== '');
};
